import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { Box, ChakraProvider, CSSReset } from '@chakra-ui/react';
import { settings } from '../settings';
import useUserStore from '../stores/user-store';
import PipelineFetcher from './PipelineFetcher';
// import Editor from "./editor/Editor";

import SignIn from './sign-in/SignIn';
import PipelineEditor from './pipeline-editor/PipelineEditor';
import { InstancesInspector } from './InstancesInspector';
import { CycleInspector } from './CycleInspector';

function App() {
    const { sessionToken } = useUserStore();
    let pipelineId: string | undefined;
    let cycleId: string | undefined;
    let instanceIds: string[] | undefined;

    if (window.location.pathname.split('/').length <= 2) {
        pipelineId = window.location.pathname.split('/')[1];
    } else if (window.location.pathname.split('/')[1] == 'instances') {
        instanceIds = window.location.pathname.split('/')[2].replaceAll(' ', '').split(',');
    } else if (window.location.pathname.split('/')[1] == 'cycle') {
        cycleId = window.location.pathname.split('/')[2];
    }

    if (sessionToken && !pipelineId && !instanceIds && !cycleId) {
        return <Box>Error params</Box>;
    }

    const apolloClient = new ApolloClient({
        uri: settings.GQL_URL,
        cache: new InMemoryCache(),
        headers: {
            Authorization: `Bearer ${sessionToken}`,
        },
    });
    return (
        <ApolloProvider client={apolloClient}>
            <CSSReset />
            <ChakraProvider>
                {!sessionToken && <SignIn />}
                {sessionToken && pipelineId && (
                    <>
                        <PipelineFetcher />
                        <PipelineEditor />
                    </>
                )}
                {sessionToken && instanceIds && <InstancesInspector instanceIds={instanceIds} />}
                {sessionToken && cycleId && <CycleInspector cycleId={cycleId} />}
            </ChakraProvider>
        </ApolloProvider>
    );
}

export default App;
